function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FYI-Document-Icons",
  transform: "translate(-216.000000, -1038.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Video",
  transform: "translate(0.000000, 1010.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Main",
  transform: "translate(216.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#E22C26",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.56125,21.8615625 L10.25125,15.13 C10.113125,15.04875 9.9709375,15 9.8084375,15 C9.365625,15 9.0040625,15.365625 9.0040625,15.8125 L9,15.8125 L9,29.7875 L9.0040625,29.7875 C9.0040625,30.234375 9.365625,30.6 9.8084375,30.6 C9.975,30.6 10.113125,30.543125 10.2634375,30.461875 L21.56125,23.7384375 C21.829375,23.515 22,23.1778125 22,22.8 C22,22.4221875 21.829375,22.0890625 21.56125,21.8615625 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#FD5853",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
})))));

var SvgVideo = function SvgVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video.a1d55563.svg";
export { ForwardRef as ReactComponent };